import React from 'react';
import PropTypes from 'prop-types';
import WStoreGem from 'containers/WStorePage/WStoreGem';
import { WSCORE } from 'utils/constants';
// import './WStoreTrades.css';

function WStoreTradeItem({ wscoreAmount, gemType, gemAmount }) {
  return (
    <>
      <div className="give-trade">
        <div className="item-title"> Trade: </div>
        <WStoreGem gemType={WSCORE} amount={wscoreAmount} large />
      </div>
      <div className="acquire-trade">
        <div className="item-title"> To Acquire: </div>
        <WStoreGem gemType={gemType} amount={gemAmount} large />
      </div>
    </>
  );
}

WStoreTradeItem.propTypes = {
  wscoreAmount: PropTypes.number.isRequired,
  gemType: PropTypes.string.isRequired,
  gemAmount: PropTypes.number.isRequired
};

export default WStoreTradeItem;
